import UiElement from '../../../shared/ui-element/ui-element';

class RangeSlider extends UiElement {
  constructor({ ...props }) {
    super();
    this.changeHandler = props.changeHandler;
    this.defaultValue = props.defaultValue;
  }

  ui = {
    slider: '[data-range-slider]',
    value: '[data-range-value]',
  };

  events = {
    'input @ui.slider': 'handleChange',
  };

  onInit() {
    super.onInit();

    this.ui.value.innerHTML = this.defaultValue;
  }

  handleChange = (event) => {
    const { target: { value } } = event;

    this.ui.value.innerHTML = value;

    if (this.changeHandler) {
      this.changeHandler(value);
    }
  };
}

export default RangeSlider;
